import { put, call, takeEvery, takeLeading, takeLatest, select } from "redux-saga/effects";
import { propertyListAction } from "../../../slices/admin/admin-dashboard/propertyListSlice";
import { postAPIPayload, patchAPIPayload } from "../../../../apis/postApi";
import { getAPIPayload } from "../../../../apis/getApi";
import {
  buildViewPropertyCacheKey,
  resolveViewPropertyCategory,
} from "../../../../components/admin/AdminDashboard/propertyViewDetailsCache";

export function* fetchAllPropertiesSaga({ payload }) {
  console.log("In sagas -->", payload);
  const response = yield call(postAPIPayload, payload);
  console.log("All properties response => ", response);
  yield put(propertyListAction.fetchPropertyListData(response));
}

export function* fetchUserWorkspacePropertyListSaga({ payload }) {
  try {
    const response = yield call(getAPIPayload, payload);
    yield put(
      propertyListAction.fetchUserWorkspacePropertyListData(
        response && typeof response === "object"
          ? response
          : {
              success: false,
              message: "Unable to load user properties.",
              data: [],
            },
      ),
    );
  } catch (error) {
    yield put(
      propertyListAction.fetchUserWorkspacePropertyListData({
        success: false,
        message: error?.message || "Unable to load user properties.",
        data: [],
      }),
    );
  }
}

export function* fetchPropertyDocumentSaga({ payload }) {
  console.log("In fetching property document -->", payload);
  const response = yield call(postAPIPayload, payload);
  console.log("Request Property Document response", response);
  yield put(propertyListAction.fetchRequestPropertyDocument(response));
}

export function* fetchUploadedPropertyDocuments({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // Set document data in redux
  yield put(propertyListAction.fetchUploadedPropertyDocuments(response));
}
export function* fetchReplacedPropertyDocuments({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // Set document data in redux
  yield put(propertyListAction.fetchReplacedPropertyDocuments(response));
}
export function* fetchUploadedPropertyGeneralDocumentsSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // Set document data in redux
  yield put(propertyListAction.fetchUploadedPropertyGeneralDocuments(response));
}
export function* bindProfessionalsToPropertySaga({ payload }) {
  console.log("bind payload", payload);
  const response = yield call(postAPIPayload, payload);

  // set datta to store
  yield put(propertyListAction.setBindProfessionalDetails(response));
}

export function* verifyAddressSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set datta to store
  yield put(propertyListAction.setVerifyAddressDetails(response));
}

export function* getAdminViewPropertyDetailsSaga({ payload }) {
  const propertyId = payload?.data?.id;
  const category = resolveViewPropertyCategory(payload?.data || {});
  const cacheKey = propertyId
    ? buildViewPropertyCacheKey(propertyId, category)
    : null;
  const forceRefresh = Boolean(payload?.data?.refresh);

  if (cacheKey && !forceRefresh) {
    const cached = yield select(
      (state) => state.propertyLists.viewPropertyDetailsCache[cacheKey],
    );

    if (cached?.success) {
      yield put(propertyListAction.setAdminViewPropertyDetails(cached));
      return;
    }
  }

  const response = yield call(postAPIPayload, payload);

  yield put(propertyListAction.setAdminViewPropertyDetails(response));
}

export function* cancelSubscriptionSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyListAction.setCanceledSubscription(response));
}

export function* getChangeSubscriptionPlanListSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(propertyListAction.setChangeSubscriptionPlanList(response));
}

export function* changeSubscriptionPlanSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyListAction.setChangedSubscriptionPlan(response));
}

export function* cancelChangeSubscriptionRequestSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(propertyListAction.setCancelChangeSubscriptionRequest(response));
}

export function* sendRefundRecordingFeesSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyListAction.setRefundRecordingFeesDetails(response));
}

export function* resendPostcardSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(propertyListAction.setResendPostcardDetails(response));
}

export function* updateMailingAddressSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyListAction.fetchUpdateMailingAddressDetails(response));
}

export function* updateZipCodeSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyListAction.fetchUpdateZipCodeDetails(response));
}

export function* closingAdminLeadsSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyListAction.fetchClosingAdminDetails(response));
}

export function* reRecordUCCDocDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyListAction.fetchReRecordUCCDocData(response));
}

export function* updateUccRecordingDetailsSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyListAction.setUccRecordingDetails(response));
}

export function* updatePropertyUccStatusSaga({ payload }) {
  const response = yield call(patchAPIPayload, payload);
  yield put(propertyListAction.setUpdatePropertyUccStatus(response));
}

export function* fetchUserEmailHistorySaga({ payload }) {
  const isUserEmailHistory =
    payload?.method === "GET" || payload?.url?.includes("/users/");
  const response = yield call(
    isUserEmailHistory ? getAPIPayload : postAPIPayload,
    payload,
  );
  yield put(propertyListAction.setUserEmailHistory(response));
}

export function* fetchEmailHistoryDetailSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(propertyListAction.setEmailHistoryDetail(response));
}

export function* resendEmailHistorySaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyListAction.setResendEmailHistory(response));
}

export function* watchPropertyListsSagaAsync() {
  yield takeLeading(
    propertyListAction.getPropertyListData,
    fetchAllPropertiesSaga,
  );
  yield takeLeading(
    propertyListAction.getUserWorkspacePropertyListData,
    fetchUserWorkspacePropertyListSaga,
  );
  yield takeEvery(
    propertyListAction.getRequestPropertyDocument,
    fetchPropertyDocumentSaga,
  );
  yield takeEvery(
    propertyListAction.getUploadedPropertyDocuments,
    fetchUploadedPropertyDocuments,
  );
  yield takeEvery(
    propertyListAction.getReplacedPropertyDocuments,
    fetchReplacedPropertyDocuments,
  );
  yield takeEvery(
    propertyListAction.getUploadedPropertyGeneralDocuments,
    fetchUploadedPropertyGeneralDocumentsSaga,
  );
  yield takeEvery(
    propertyListAction.bindProfessionalsToProperty,
    bindProfessionalsToPropertySaga,
  );
  yield takeEvery(
    propertyListAction.getAdminViewPropertyDetails,
    getAdminViewPropertyDetailsSaga,
  );
  yield takeEvery(propertyListAction.verifyAddress, verifyAddressSaga);
  yield takeEvery(
    propertyListAction.cancelSubscription,
    cancelSubscriptionSaga,
  );
  yield takeEvery(
    propertyListAction.getChangeSubscriptionPlanList,
    getChangeSubscriptionPlanListSaga,
  );
  yield takeEvery(
    propertyListAction.changeSubscriptionPlan,
    changeSubscriptionPlanSaga,
  );
  yield takeEvery(
    propertyListAction.cancelChangeSubscriptionRequest,
    cancelChangeSubscriptionRequestSaga,
  );
  yield takeEvery(
    propertyListAction.sendRefundRecordingFees,
    sendRefundRecordingFeesSaga,
  );
  yield takeEvery(propertyListAction.resendPostcard, resendPostcardSaga);
  yield takeEvery(
    propertyListAction.getUpdateMailingAddress,
    updateMailingAddressSaga,
  );
  yield takeEvery(propertyListAction.getUpdateZipCode, updateZipCodeSaga);
  yield takeEvery(
    propertyListAction.getClosingAdminDetails,
    closingAdminLeadsSaga,
  );
  yield takeEvery(
    propertyListAction.getReRecordUCCDocData,
    reRecordUCCDocDataSaga,
  );
  yield takeEvery(
    propertyListAction.updateUccRecordingDetails,
    updateUccRecordingDetailsSaga,
  );
  yield takeEvery(
    propertyListAction.updatePropertyUccStatus,
    updatePropertyUccStatusSaga,
  );
  yield takeEvery(
    propertyListAction.fetchUserEmailHistory,
    fetchUserEmailHistorySaga,
  );
  yield takeEvery(
    propertyListAction.fetchEmailHistoryDetail,
    fetchEmailHistoryDetailSaga,
  );
  yield takeEvery(
    propertyListAction.resendEmailHistory,
    resendEmailHistorySaga,
  );
}
